
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.1.0
 * @copyright  Copyright (C) 2025-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 *  2025-02-10 (1.0.0) (jhoward)
 *    - Copy from Thanksgiving_defaultSection.vue component to ValentinesDay_defaultSection.vue component.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <ValentinesDay_defaultSection>.
 *
 * 2026-02-06 (2.1.0) (jhoward)
 *   - Update header image references to new 2026 asset and adjust alt text.
 *   - Add .menu--section_background div for enhanced section visuals.
 *   - Modify sectionTitle() logic to match new title string and return empty string for 'valentine's day dining'.
 *   - Revise section and background CSS: new padding, background image, sizing, and responsive rules.
 *   - Adjust highlight and description font sizes and colors for improved readability.
 *   - Add mobile-specific styles for section layout and image display.
 *   - Refine visual menu container and section positioning for new assets.
 */

import { defineComponent, PropType } from "vue";
import { ALLOWED_ITEM_COMPONENTS, Menu, MenuSection } from "../defs";

export default defineComponent({
  name: "StPatricksDay_drinkSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true,
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true,
    },
    menuItemComponent: {
      type: String,
      default: "valentines-day-food-item",
      validate: (value: string) =>
        "" === value || ALLOWED_ITEM_COMPONENTS.indexOf(value),
    },
  },
});
